import React from 'react';
import { SEOHead } from '../Components/common/SEOHead';
import './PrivacyPolicy.css';

export function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <SEOHead
        title="Privacy Policy"
        description="Privacy Policy for BasedOn - Learn how we handle your personal information when using our Power BI custom visuals."
        canonical="https://based-on.net/privacy"
        noindex={false}
      />

      <section className="privacy-hero">
        <div className="privacy-dot-grid privacy-dot-grid-left" aria-hidden="true" />
        <div className="privacy-dot-grid privacy-dot-grid-right" aria-hidden="true" />
        <div className="privacy-wave" aria-hidden="true" />

        <div className="privacy-hero-content">
          <h1>Privacy Policy</h1>
          <div className="privacy-title-mark" />
          <p>Last updated: October 13, 2025</p>
        </div>
      </section>

      <section className="privacy-main">
        <article className="privacy-card">
          <p className="privacy-intro">
            At Based On, operated by <strong>BASED ON LLC</strong>, we value the privacy of our users. This Privacy Policy outlines how we handle any personal information you provide when using our custom visual in Power BI.
          </p>

          <section className="privacy-section">
            <h2>Information We Collect</h2>
            <p>
              In addition to the email address you provide when contacting us, we use third-party analytics services, including Google Analytics and Cloudflare Analytics, to collect information about how visitors interact with our website. This may include IP addresses, browser types, device information, pages visited, and interactions with the site.
            </p>
            <p>
              This data is collected in an anonymized form and used solely to analyze website traffic and improve our services.
            </p>
            <p>We do not use cookies for personalized advertising or user profiling.</p>
          </section>

          <section className="privacy-section">
            <h2>How We Use Your Information</h2>
            <p>
              The email address you provide is used solely for the purpose of responding to your inquiries, support requests, or communications. We will not use your email address for marketing purposes unless you opt-in to receive marketing materials.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Cookies and Tracking Technologies</h2>
            <p>
              Our website uses cookies and similar tracking technologies for analytics purposes. You can manage your cookie preferences through your browser settings.
            </p>
            <p>
              Google Analytics may use cookies to collect and analyze website usage data. You can opt out of Google Analytics tracking by using the <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.
            </p>
            <p>We use Google Analytics with IP anonymization enabled.</p>
          </section>

          <section className="privacy-section">
            <h2>Data Retention</h2>
            <p>
              We retain the email address you provide only for as long as needed to address your inquiry or provide support. Once your inquiry is resolved, we will delete or anonymize your data as appropriate.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Data Sharing</h2>
            <p>
              We do not share, sell, or rent personal data. However, Google Analytics and Cloudflare Analytics process usage data as described in their respective privacy policies:
            </p>
            <ul>
              <li>
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Analytics: https://policies.google.com/privacy</a>
              </li>
              <li>
                <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer">Cloudflare Analytics: https://www.cloudflare.com/privacypolicy/</a>
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>Security</h2>
            <p>
              We take reasonable steps to ensure that any personal information you provide is kept secure. However, please note that no method of transmission over the internet or electronic storage is completely secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Your Rights</h2>
            <p>
              You have the right to request access to, correction of, or deletion of your personal information by contacting us at <a href="mailto:support@based-on.net">support@based-on.net</a>.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify users of any significant changes by updating the effective date at the top of this page.
            </p>
          </section>

          <section className="privacy-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please feel free to contact us at <a href="mailto:support@based-on.net">support@based-on.net</a>.
            </p>
          </section>
        </article>
      </section>
    </div>
  );
}
